import type { GiphyItem } from "./types";

const getContentType = (gif: GiphyItem): string =>
  gif.type === "video" ? "video/mp4" : "image/gif";

const getExtension = (contentType: string): string => contentType.split("/")[1];

export const giphyToFile = async (gif: GiphyItem): Promise<File> => {
  const response = await fetch(gif.images.original.url);
  const blob = await response.blob();
  const contentType = getContentType(gif);
  return new File([blob], `${gif.id}.${getExtension(contentType)}`, {
    type: contentType,
  });
};
